import { useState } from "react";
import FullImageModal from "../../full-image-modal";
import Thumbnail from "../../thumbnail";

const DimensionDescriptionThumbnailsLayout = ({ data }) => {
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState();

  const clickThumbnailHandler = (event, image) => {
    event.preventDefault();
    setModalIsVisible(true);
    setSelectedImage(image);
  };

  const closeModalHandler = () => setModalIsVisible(false);

  const { lead, thumbnails } = data;
  return (
    <>
      {lead && <div className="mb-2">{lead}</div>}
      <div className="thumbnails">
        {thumbnails.map((thumbnail, thumbnailIndex) => {
          const { name, route } = thumbnail;
          const thumbnailRoute = require(`../../../assets/img/${route}.png`);
          return (
            <Thumbnail
              key={`thumbnail-${thumbnailIndex}_${route}_png`}
              name={name}
              image={thumbnailRoute}
              onClickThumbnail={(event) => clickThumbnailHandler(event, thumbnailRoute)}
            />
          );
        })}
      </div>
      <FullImageModal
        id="fullImageModal"
        image={selectedImage}
        isVisible={modalIsVisible}
        onCloseModal={closeModalHandler}
      />
    </>
  );
};

export default DimensionDescriptionThumbnailsLayout;
